/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { EnterpriseInsightsRequest } from '../model/enterpriseInsightsRequest';
// @ts-ignore
import { HTTPValidationError } from '../model/hTTPValidationError';
// @ts-ignore
import { InsightCategory } from '../model/insightCategory';
// @ts-ignore
import { InsightDetailResponse } from '../model/insightDetailResponse';
// @ts-ignore
import { InsightFeedback } from '../model/insightFeedback';
// @ts-ignore
import { InsightFeedbackRequest } from '../model/insightFeedbackRequest';
// @ts-ignore
import { InsightInteractionRequest } from '../model/insightInteractionRequest';
// @ts-ignore
import { InsightListResponse } from '../model/insightListResponse';
// @ts-ignore
import { OrganisationInsightsRequest } from '../model/organisationInsightsRequest';
// @ts-ignore
import { SiteInsightsRequest } from '../model/siteInsightsRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class InsightsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get Insight Detail
     * Get full insight detail with all tabs.  A card the caller may not view in its domain is reported as not found, so its existence is not disclosed.  Raises:     HTTPException: 401 when the request carries no access token, 404 when the insight does not         exist or the caller may not view it, and 503 when the caller\&#39;s permissions or the         database are unavailable.
     * @endpoint get /insights/detail/{insight_id}
     * @param insightId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getInsightDetailInsightsDetailInsightIdGet(insightId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<InsightDetailResponse>;
    public getInsightDetailInsightsDetailInsightIdGet(insightId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<InsightDetailResponse>>;
    public getInsightDetailInsightsDetailInsightIdGet(insightId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<InsightDetailResponse>>;
    public getInsightDetailInsightsDetailInsightIdGet(insightId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (insightId === null || insightId === undefined) {
            throw new Error('Required parameter insightId was null or undefined when calling getInsightDetailInsightsDetailInsightIdGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/insights/detail/${this.configuration.encodeParam({name: "insightId", value: insightId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<InsightDetailResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List Enterprise Insights
     * List the cards whose subject is the named company, and none from beneath it.
     * @endpoint post /insights/enterprise/{domain}
     * @param domain 
     * @param enterpriseInsightsRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listEnterpriseInsightsInsightsEnterpriseDomainPost(domain: string, enterpriseInsightsRequest: EnterpriseInsightsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<InsightListResponse>;
    public listEnterpriseInsightsInsightsEnterpriseDomainPost(domain: string, enterpriseInsightsRequest: EnterpriseInsightsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<InsightListResponse>>;
    public listEnterpriseInsightsInsightsEnterpriseDomainPost(domain: string, enterpriseInsightsRequest: EnterpriseInsightsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<InsightListResponse>>;
    public listEnterpriseInsightsInsightsEnterpriseDomainPost(domain: string, enterpriseInsightsRequest: EnterpriseInsightsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (domain === null || domain === undefined) {
            throw new Error('Required parameter domain was null or undefined when calling listEnterpriseInsightsInsightsEnterpriseDomainPost.');
        }
        if (enterpriseInsightsRequest === null || enterpriseInsightsRequest === undefined) {
            throw new Error('Required parameter enterpriseInsightsRequest was null or undefined when calling listEnterpriseInsightsInsightsEnterpriseDomainPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/insights/enterprise/${this.configuration.encodeParam({name: "domain", value: domain, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<InsightListResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: enterpriseInsightsRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List Insight Categories
     * List canonical insight categories available across all domains.
     * @endpoint get /insights/categories
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listInsightCategoriesInsightsCategoriesGet(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<InsightCategory>>;
    public listInsightCategoriesInsightsCategoriesGet(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<InsightCategory>>>;
    public listInsightCategoriesInsightsCategoriesGet(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<InsightCategory>>>;
    public listInsightCategoriesInsightsCategoriesGet(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/insights/categories`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<InsightCategory>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List Organisation Insights
     * List the cards whose subject is one of the named organisations, and none from beneath them.  Raises:     HTTPException: 401 when the request carries no access token, 400 when the published         structure cannot name one of the organisations, and 503 when that structure cannot be         read at all.
     * @endpoint post /insights/organisation/{domain}
     * @param domain 
     * @param organisationInsightsRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listOrganisationInsightsInsightsOrganisationDomainPost(domain: string, organisationInsightsRequest: OrganisationInsightsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<InsightListResponse>;
    public listOrganisationInsightsInsightsOrganisationDomainPost(domain: string, organisationInsightsRequest: OrganisationInsightsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<InsightListResponse>>;
    public listOrganisationInsightsInsightsOrganisationDomainPost(domain: string, organisationInsightsRequest: OrganisationInsightsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<InsightListResponse>>;
    public listOrganisationInsightsInsightsOrganisationDomainPost(domain: string, organisationInsightsRequest: OrganisationInsightsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (domain === null || domain === undefined) {
            throw new Error('Required parameter domain was null or undefined when calling listOrganisationInsightsInsightsOrganisationDomainPost.');
        }
        if (organisationInsightsRequest === null || organisationInsightsRequest === undefined) {
            throw new Error('Required parameter organisationInsightsRequest was null or undefined when calling listOrganisationInsightsInsightsOrganisationDomainPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/insights/organisation/${this.configuration.encodeParam({name: "domain", value: domain, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<InsightListResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: organisationInsightsRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List Site Insights
     * List the cards whose subject is one of the named sites or facilities.
     * @endpoint post /insights/site/{domain}
     * @param domain 
     * @param siteInsightsRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listSiteInsightsInsightsSiteDomainPost(domain: string, siteInsightsRequest: SiteInsightsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<InsightListResponse>;
    public listSiteInsightsInsightsSiteDomainPost(domain: string, siteInsightsRequest: SiteInsightsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<InsightListResponse>>;
    public listSiteInsightsInsightsSiteDomainPost(domain: string, siteInsightsRequest: SiteInsightsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<InsightListResponse>>;
    public listSiteInsightsInsightsSiteDomainPost(domain: string, siteInsightsRequest: SiteInsightsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (domain === null || domain === undefined) {
            throw new Error('Required parameter domain was null or undefined when calling listSiteInsightsInsightsSiteDomainPost.');
        }
        if (siteInsightsRequest === null || siteInsightsRequest === undefined) {
            throw new Error('Required parameter siteInsightsRequest was null or undefined when calling listSiteInsightsInsightsSiteDomainPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/insights/site/${this.configuration.encodeParam({name: "domain", value: domain, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<InsightListResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: siteInsightsRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Record Insight Interaction
     * Record one interaction event (dismiss/favourite/seen/acknowledge) for the caller.
     * @endpoint post /insights/{occurrence_id}/interactions
     * @param occurrenceId 
     * @param insightInteractionRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public recordInsightInteractionInsightsOccurrenceIdInteractionsPost(occurrenceId: string, insightInteractionRequest: InsightInteractionRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public recordInsightInteractionInsightsOccurrenceIdInteractionsPost(occurrenceId: string, insightInteractionRequest: InsightInteractionRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public recordInsightInteractionInsightsOccurrenceIdInteractionsPost(occurrenceId: string, insightInteractionRequest: InsightInteractionRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public recordInsightInteractionInsightsOccurrenceIdInteractionsPost(occurrenceId: string, insightInteractionRequest: InsightInteractionRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (occurrenceId === null || occurrenceId === undefined) {
            throw new Error('Required parameter occurrenceId was null or undefined when calling recordInsightInteractionInsightsOccurrenceIdInteractionsPost.');
        }
        if (insightInteractionRequest === null || insightInteractionRequest === undefined) {
            throw new Error('Required parameter insightInteractionRequest was null or undefined when calling recordInsightInteractionInsightsOccurrenceIdInteractionsPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/insights/${this.configuration.encodeParam({name: "occurrenceId", value: occurrenceId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/interactions`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: insightInteractionRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Upsert Insight Feedback
     * Upsert the caller\&#39;s feedback for one occurrence.  &#x60;categories&#x60;/&#x60;details&#x60; omitted (None) in the request preserve the caller\&#39;s previously stored value for that field rather than clearing it.
     * @endpoint put /insights/{occurrence_id}/feedback
     * @param occurrenceId 
     * @param insightFeedbackRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public upsertInsightFeedbackInsightsOccurrenceIdFeedbackPut(occurrenceId: string, insightFeedbackRequest: InsightFeedbackRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<InsightFeedback>;
    public upsertInsightFeedbackInsightsOccurrenceIdFeedbackPut(occurrenceId: string, insightFeedbackRequest: InsightFeedbackRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<InsightFeedback>>;
    public upsertInsightFeedbackInsightsOccurrenceIdFeedbackPut(occurrenceId: string, insightFeedbackRequest: InsightFeedbackRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<InsightFeedback>>;
    public upsertInsightFeedbackInsightsOccurrenceIdFeedbackPut(occurrenceId: string, insightFeedbackRequest: InsightFeedbackRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (occurrenceId === null || occurrenceId === undefined) {
            throw new Error('Required parameter occurrenceId was null or undefined when calling upsertInsightFeedbackInsightsOccurrenceIdFeedbackPut.');
        }
        if (insightFeedbackRequest === null || insightFeedbackRequest === undefined) {
            throw new Error('Required parameter insightFeedbackRequest was null or undefined when calling upsertInsightFeedbackInsightsOccurrenceIdFeedbackPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/insights/${this.configuration.encodeParam({name: "occurrenceId", value: occurrenceId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/feedback`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<InsightFeedback>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: insightFeedbackRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
